import React from 'react'

import { BaseView } from '@/components/base'
import { AppButton } from '@/components/AppButton'
import { ButtonProps } from '@/components/AppButton/types'
import { useTheme } from '@/hooks/useTheme'
import useOffsets from '@/hooks/useOffsets'

export interface FixedBottomButtonProps {
  /**
   * Основная кнопка или массив кнопок
   */
  buttons: ButtonProps | ButtonProps[]

  /**
   * Показывать ли верхнюю границу
   * @default false
   */
  showBorder?: boolean

  /**
   * Дополнительные стили для контейнера
   */
  containerStyle?: React.CSSProperties

  /**
   * Z-index для позиционирования
   * @default 1000
   */
  zIndex?: number

  /**
   * Дополнительный отступ снизу (добавляется к offsets.bottom)
   * @default 12
   */
  additionalBottomPadding?: number
}

export const FixedBottomButton: React.FC<FixedBottomButtonProps> = ({
  buttons,
  showBorder = false,
  containerStyle,
  zIndex = 1000,
  additionalBottomPadding = 12,
}) => {
  const theme = useTheme()
  const offsets = useOffsets()

  const buttonsArray = Array.isArray(buttons) ? buttons : [buttons]
  const isMultipleButtons = buttonsArray.length > 1

  return (
    <BaseView
      px={12}
      pt={8}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: theme.colors.background.screen,
        paddingBottom: offsets.bottom,
        zIndex,
        ...(showBorder && {
          borderTop: `1px solid ${theme.colors.background.secondaryGray}`,
        }),
        ...containerStyle,
      }}
    >
      {isMultipleButtons ? (
        // Несколько кнопок в ряд
        <BaseView row gap={12}>
          {buttonsArray.map((buttonProps, index) => (
            <AppButton key={index} isSharedSpace {...buttonProps} />
          ))}
        </BaseView>
      ) : (
        // Одна кнопка на всю ширину
        <AppButton {...buttonsArray[0]} />
      )}
    </BaseView>
  )
}

export default FixedBottomButton
